import { render, staticRenderFns } from "./changePhone.vue?vue&type=template&id=0a22e214"
import script from "./changePhone.vue?vue&type=script&lang=ts"
export * from "./changePhone.vue?vue&type=script&lang=ts"
import style0 from "./changePhone.vue?vue&type=style&index=0&id=0a22e214&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports